import React from "react";
import { useTranslation } from "react-i18next";
import DeleteDialogStyle from "styles/application/DeleteDialogStyle";
import Dialog from "@mui/material/Dialog";
import { LinearProgress } from "@mui/material";

// Init styled components
const ADD = DeleteDialogStyle();

const ConfirmDialog = ({
	open,
	closeHandler,
	handleImport,
	loading,
	emptyRoles,
}) => {
	const { t } = useTranslation();
	const EmptyRole = () => {
		return (
			<ul>
				{emptyRoles.map((e) => (
					<li>{e}</li>
				))}
			</ul>
		);
	};

	const customCaptions = localStorage.getItem("me")
		? JSON.parse(localStorage.getItem("me"))?.customCaptions
		: {};

	return (
		<div>
			<Dialog
				open={open}
				onClose={closeHandler}
				aria-labelledby="confirm-title"
				aria-describedby="confirm-description"
			>
				{loading ? <LinearProgress /> : null}

				<ADD.ActionContainer>
					<ADD.ButtonContainer>
						<ADD.DeleteButton onClick={closeHandler} variant="contained">
							{t("action.cancel")}
						</ADD.DeleteButton>

						<ADD.CancelButton onClick={handleImport} variant="contained">
							{t("action.proceed")}
						</ADD.CancelButton>
					</ADD.ButtonContainer>
				</ADD.ActionContainer>

				<ADD.DialogContent>
					<ADD.InputContainer id="alert-dialog-description">
						{t("message.followingEntitiesNotMapped", {
							entity: customCaptions?.rolePlural,
						})}
						<EmptyRole />
						{t("message.proceedWithoutMappingConfirm", {
							entity: customCaptions?.rolePlural,
						})}
					</ADD.InputContainer>
				</ADD.DialogContent>
			</Dialog>
		</div>
	);
};

export default ConfirmDialog;
